import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=65037db2&scoped=true"
import script from "./LeadDetails.vue?vue&type=script&lang=ts"
export * from "./LeadDetails.vue?vue&type=script&lang=ts"
import style0 from "./LeadDetails.vue?vue&type=style&index=0&id=65037db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65037db2",
  null
  
)

export default component.exports